import { DatabaseModel, DatabaseModelElement } from "./DatabaseModel";
import { GridLegacy } from "@mui/material";
import { Visibility } from "@mui/icons-material";
import React from "react";
// @ts-ignore
import { Link } from "react-router";
import Reseller from "./Reseller";
import Debtor from "./Debtor";

export default class PricePlan extends DatabaseModel implements DatabaseModelElement {
  static modelName = "subsPricePlan";

  constructor(
    public id: number = 0,
    public name: string = "",
    public description: string = "",
    public license_month_mask: string = "111111111111",
    public invoice_month_mask: string = "111111111111",
    public price_monthly: number = 0,
    public price_monthly_commission: number = 0,
    public price_digital_menu_card_monthly: number = 0,
    public price_digital_menu_card_monthly_commission: number = 0,
    public price_core_qr_monthly: number = 0,
    public price_core_qr_monthly_commission: number = 0,
    public price_core_tablet_monthly: number = 0,
    public price_core_tablet_monthly_commission: number = 0,
    public price_core_kiosk_monthly: number = 0,
    public price_core_kiosk_monthly_commission: number = 0,
    public price_core_webshop_monthly: number = 0,
    public price_core_webshop_monthly_commission: number = 0,
    public price_extra_qr_monthly: number = 0,
    public price_extra_qr_monthly_commission: number = 0,
    public price_extra_tablet_monthly: number = 0,
    public price_extra_tablet_monthly_commission: number = 0,
    public price_extra_kiosk_monthly: number = 0,
    public price_extra_kiosk_monthly_commission: number = 0,
    public price_extra_webshop_monthly: number = 0,
    public price_extra_webshop_monthly_commission: number = 0,
    public price_server_basic_monthly: number = 0,
    public price_server_basic_monthly_commission: number = 0,
    public price_sales_area_monthly: number = 0,
    public price_sales_area_monthly_commission: number = 0,
    public price_psp_integration_monthly: number = 0,
    public price_psp_integration_monthly_commission: number = 0,
    public price_pos_integration_monthly: number = 0,
    public price_pos_integration_monthly_commission: number = 0,
    public price_gateway_monthly: number = 0,
    public price_gateway_monthly_commission: number = 0,
    public price_per_sms_local_country: number = 0,
    public price_per_sms_local_country_commission: number = 0,
    public price_per_sms_foreign_country: number = 0,
    public price_per_sms_foreign_country_commission: number = 0,
    public price_per_order: number = 0,
    public price_per_order_commission: number = 0,
    public price_standalone_monthly: number = 0,
    public price_standalone_monthly_commission: number = 0,
    public price_whitelabel_monthly: number = 0,
    public price_whitelabel_monthly_commission: number = 0,
    public price_startup_fee: number = 0,
    public price_startup_fee_commission: number = 0,
    public monthly_surcharge: number = 0.3,
    public monthly_discount: number | null = null,
    public payments: any | null = null,
    public tax_rate: number = 0.21,
    public subs_debtor_id: number | null = null,
    public created_at: Date = new Date(),
    public updated_at: Date = new Date(),
    public deleted_at: Date | null = null,
    public resellers: Reseller[] = [],
    public subsPricePlan: PricePlan | null = null,
    public subsDebtor: Debtor | null = null
  ) {
    super();
  }

  static CreateModel(model: any): PricePlan {
    return new PricePlan(
      model.id,
      model.name,
      model.description,
      model.license_month_mask,
      model.invoice_month_mask,
      model.price_monthly,
      model.price_monthly_commission,
      model.price_digital_menu_card,
      model.price_digital_menu_card_commission,
      model.price_core_qr_monthly,
      model.price_core_qr_monthly_commission,
      model.price_core_tablet_monthly,
      model.price_core_tablet_monthly_commission,
      model.price_core_kiosk_monthly,
      model.price_core_kiosk_monthly_commission,
      model.price_core_webshop_monthly,
      model.price_core_webshop_monthly_commission,
      model.price_extra_qr_monthly,
      model.price_extra_qr_monthly_commission,
      model.price_extra_tablet_monthly,
      model.price_extra_tablet_monthly_commission,
      model.price_extra_kiosk_monthly,
      model.price_extra_kiosk_monthly_commission,
      model.price_extra_webshop_monthly,
      model.price_extra_webshop_monthly_commission,
      model.price_server_basic_monthly,
      model.price_server_basic_monthly_commission,
      model.price_sales_area_monthly,
      model.price_sales_area_monthly_commission,
      model.price_psp_integration_monthly,
      model.price_psp_integration_monthly_commission,
      model.price_pos_integration_monthly,
      model.price_pos_integration_monthly_commission,
      model.price_gateway_monthly,
      model.price_gateway_monthly_commission,
      model.price_per_sms_local_country,
      model.price_per_sms_local_country_commission,
      model.price_per_sms_foreign_country,
      model.price_per_sms_foreign_country_commission,
      model.price_per_order,
      model.price_per_order_commission,
      model.price_standalone_monthly,
      model.price_standalone_monthly_commission,
      model.price_whitelabel_monthly,
      model.price_whitelabel_monthly_commission,
      model.price_startup_fee,
      model.price_startup_fee_commission,
      model.monthly_surcharge,
      model.monthly_discount,
      model.payments,
      model.tax_rate,
      model.subs_debtor_id,
      new Date(model.created_at),
      new Date(model.updated_at),
      model.deleted_at ? new Date(model.deleted_at) : null,
      model.subs_resellers ? model.subs_resellers.map((reseller: object) => Reseller.CreateModel(reseller)) : [],
      model.subs_price_plan ? PricePlan.CreateModel(model.subs_price_plan) : null,
      model.subs_debtor ? Debtor.CreateModel(model.subs_debtor) : null
    );
  }

  tableRow() {
    return (
      <>
        <GridLegacy item xs={6}>
          {this.description}
        </GridLegacy>
        <GridLegacy item xs={6}>
          <Link to={{ pathname: PricePlan.editPath(this.id) }}>
            <Visibility />
          </Link>
        </GridLegacy>
      </>
    );
  }
}
